import { clasolSuiteApi } from '../axiosConfig'
import { withCacheBuster } from '../apiHelpers'

export const login = async (credentials) => {
  const { data } = await clasolSuiteApi.post('/auth/login', credentials)
  return data
}

export const refreshSession = async () => {
  const { data } = await clasolSuiteApi.post('/auth/refresh')
  return data
}

export const getSession = async () => {
  const { data } = await clasolSuiteApi.get('/auth/me', {
    params: withCacheBuster(),
  })
  return data
}

export const getAuthSessions = async () => {
  const { data } = await clasolSuiteApi.get('/auth/sessions', {
    params: withCacheBuster(),
  })
  return data
}

export const revokeAuthSession = async (id) => {
  await clasolSuiteApi.delete(`/auth/sessions/${encodeURIComponent(id)}`)
}

export const logout = async () => {
  await clasolSuiteApi.post('/auth/logout')
}

export const logoutAll = async () => {
  await clasolSuiteApi.post('/auth/logout-all')
}
